import React from 'react';
import PropTypes from 'prop-types';

import Text from './Text';

const groupOptions = options =>
  options.reduce((list, option) => {
    const optionInList = list.find(o => o.id === option.id);
    if (!optionInList) {
      list.push({ ...option, count: 1 });
    } else {
      optionInList.count += 1;
    }
    return list;
  }, []);

export default function Options({ options, showErrors }) {
  const groupedOptions = groupOptions(options);
  const hasGrouped = groupedOptions.find(o => o.count > 1) || false;

  return groupedOptions.map((option, idx) => {
    const { id, notAvailable, count, name } = option;
    const isLast = idx === groupedOptions.length - 1;
    const text = `${hasGrouped ? `${count}x` : ''} ${name}${
      isLast ? '' : ', '
    }`;
    return (
      <Text key={id} notAvailable={notAvailable} showError={showErrors}>
        {text}
      </Text>
    );
  });
}

Options.propTypes = {
  options: PropTypes.array.isRequired,
  showErrors: PropTypes.bool.isRequired,
};
